"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var _1 = require(".");

var PanelContext_1 = __importDefault(require("../../PanelContext"));

var useCellClassName_1 = __importDefault(require("../../hooks/useCellClassName"));

var dateUtil_1 = require("../../utils/dateUtil");

var RangeContext_1 = __importDefault(require("../../RangeContext"));

exports.YEAR_COL_COUNT = 3;
var YEAR_ROW_COUNT = 4;

function YearBody(_ref) {
  var prefixCls = _ref.prefixCls,
      value = _ref.value,
      viewDate = _ref.viewDate,
      locale = _ref.locale,
      generateConfig = _ref.generateConfig,
      disabledDate = _ref.disabledDate,
      onSelect = _ref.onSelect;

  var _React$useContext = React.useContext(RangeContext_1.default),
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var _React$useContext2 = React.useContext(PanelContext_1.default),
      onDateMouseEnter = _React$useContext2.onDateMouseEnter,
      onDateMouseLeave = _React$useContext2.onDateMouseLeave;

  var yearPrefixCls = "".concat(prefixCls, "-cell"); // =============================== Year ===============================

  var yearNumber = generateConfig.getYear(viewDate);

  var startYear = Math.floor(yearNumber / _1.YEAR_DECADE_COUNT) * _1.YEAR_DECADE_COUNT;

  var endYear = startYear + _1.YEAR_DECADE_COUNT - 1;
  var baseYear = generateConfig.setYear(viewDate, startYear - Math.ceil((exports.YEAR_COL_COUNT * YEAR_ROW_COUNT - _1.YEAR_DECADE_COUNT) / 2));
  var rows = [];

  var isInView = function isInView(date) {
    var currentYearNumber = generateConfig.getYear(date);
    return startYear <= currentYearNumber && currentYearNumber <= endYear;
  };

  var getCellClassName = useCellClassName_1.default({
    cellPrefixCls: yearPrefixCls,
    value: value,
    generateConfig: generateConfig,
    rangedValue: rangedValue,
    hoverRangedValue: hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return dateUtil_1.isSameYear(generateConfig, current, target);
    },
    isInView: isInView,
    offsetCell: function offsetCell(date, offset) {
      return generateConfig.addYear(date, offset);
    }
  });

  for (var i = 0; i < YEAR_ROW_COUNT; i += 1) {
    var row = [];

    var _loop = function _loop(j) {
      var diffYear = i * exports.YEAR_COL_COUNT + j;
      var yearDate = generateConfig.addYear(baseYear, diffYear);
      var currentYearNumber = generateConfig.getYear(yearDate);
      var disabled = disabledDate && disabledDate(yearDate);
      row.push(React.createElement("td", {
        key: j,
        title: generateConfig.locale.format(locale.locale, yearDate, 'YYYY'),
        className: classnames_1.default(yearPrefixCls, _objectSpread(_defineProperty({}, "".concat(yearPrefixCls, "-disabled"), disabled), getCellClassName(yearDate))),
        onClick: function onClick() {
          if (!disabled) {
            onSelect(yearDate);
          }
        },
        onMouseEnter: function onMouseEnter() {
          if (!disabled && onDateMouseEnter) {
            onDateMouseEnter(yearDate);
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (!disabled && onDateMouseLeave) {
            onDateMouseLeave(yearDate);
          }
        }
      }, React.createElement("div", {
        className: "".concat(yearPrefixCls, "-inner")
      }, currentYearNumber)));
    };

    for (var j = 0; j < exports.YEAR_COL_COUNT; j += 1) {
      _loop(j);
    }

    rows.push(React.createElement("tr", {
      key: i
    }, row));
  }

  return React.createElement("div", {
    className: "".concat(prefixCls, "-body")
  }, React.createElement("table", {
    className: "".concat(prefixCls, "-content")
  }, React.createElement("tbody", null, rows)));
}

exports.default = YearBody;